import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';
import { H4 } from '@blueprintjs/core';

class CoocSimPopup extends React.PureComponent {

  state = {
     
  }


  render() {
        const { t,simData,nodeWord } = this.props;

        if (simData) {
            let xyTab=[];
            const keys=Object.keys(simData).sort();
            for (var i=0;i<keys.length;i++) {
                var key=keys[i];
                xyTab.push({x:key,y:simData[key]});
            }
           // prep data for the chart
            const series = [{
                name:t('logLike'),
                data:xyTab
            }];
            const options = {
                chart: {
                type: 'bar',
                height: 350
                },
                plotOptions: {
                    bar: {
                        columnWidth: '80%',
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                yaxis: {
                    title: {
                        text: t('similarity'),
                    },
                    labels: {
                        formatter: function (y) {
                        return y.toFixed(0);
                        }
                    }
                },
                xaxis: {
                    type: 'text',
                    labels: {
                        rotate: -90
                    }
                }
            };

            return (
                <>
                   
                    <Chart options={options} series={series} type="bar" height={350} />
                    <br/>
                    <center>
                        <p>{t('analogCooc')}<strong>{this.props.colloc}</strong></p>
                        <p>{t('analogCoocExplanation')} (cos &gt;= {this.props.simThreshold})</p>
                        <H4>{nodeWord}</H4>
                    </center>
                </>
               
            );
        } else {
            return (<></>)
        }
    }
}

CoocSimPopup.propTypes = {
        // see prepCoocData for an example
        simData: PropTypes.arrayOf(PropTypes.number),
        nodeWord : PropTypes.string,
        colloc : PropTypes.string,
        simThreshold : PropTypes.number
};

export default withTranslation()(CoocSimPopup);
